import axios, { AxiosInstance } from 'axios';
import { apiBlobStorage, mockAndDevelopment } from '../../app.config';

const blobStorageClient: AxiosInstance = mockAndDevelopment()
  ? axios.create()
  : axios.create({
      baseURL: apiBlobStorage(),
      headers: {
        accept: '*/*',
        contentType: 'application/json',
      },
      paramsSerializer: {
        indexes: null,
      },
    });

export default blobStorageClient;
